import React from 'react';
import Reactor from 'data/reactor';
import CreateReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import Getters from 'data/getters';

import NavigationBar from './navigation-bar';
import UserAlert from './user-alert';
import RuntimeActions from 'data/app-runtime/actions';
import { Immutable } from 'nuclear-js';

export default CreateReactClass({
    displayName: 'NavbarContainer',
    mixins: [Reactor.ReactMixin],
    propTypes: {
        route: PropTypes.string,
        includeAlert: PropTypes.bool.isRequired,
    },

    resetAlert(){
       RuntimeActions.setPageAlert(
            Immutable.Map({
                messageContent: null,
                isActive: false,
                actionStatus: '',
            })
        );
    },

    getDataBindings() {
        if (this.props.route ==='/') {
            this.resetAlert();
        }
        return {
            links: Getters.user.links,
            pageAlert: Getters.runtime.pageAlert,
            userInfo: Getters.user.userInfo,
        };
    },

    render() {
        const alertSection = this.props.includeAlert ? <UserAlert pageAlert={this.state.pageAlert} /> : null;
        return (
            <header id="page-header">
                <NavigationBar
                    route={this.props.route}
                    menuItems={this.state.links}
                    username={this.state.userInfo.get('username')}
                    key="navigation-bar"
                />
                {alertSection}
            </header>
        );
    },
});
